import React from "react";
import ImageWithBasePath from "../img/ImageWithBasePath";
// import { Link } from "react-router-dom";
import { RootState } from "../../../core/data/redux/store";
import { useSelector } from "react-redux";
import Lottie from "lottie-react";
import Loader from "../../../core/data/img/car_loading.json";
// import dayjs from "dayjs";


// const ViewBooking = (data: any) => {

export const ViewBooking = ({ BookedOn, SetDate, }: { BookedOn: any; SetDate: any, }) => {

    const { bookingDetail, bookingDetailLoading } = useSelector(
        (state: RootState) => ({
            bookingDetail: state.booking.bookingDetail,
            bookingDetailLoading: state.booking.bookingDetailLoading,

        })
    );

    return (
        <>

            {/* View Booking */}

            {<div
                className="modal new-modal multi-step fade"
                id="view_booking"
                data-keyboard="false"
                data-backdrop="static"
            >
                <div className="modal-dialog  modal-lg">
                    <div className="modal-content">
                        <div className="modal-header p-0 m-0">
                            <button
                                type="button"
                                className="close-btn"
                                data-bs-dismiss="modal"
                            >
                                <span>×</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            {bookingDetailLoading ?
                                <div className="d-flex justify-content-center align-items-center">
                                    <Lottie animationData={Loader} loop={true} style={{ width: 300, height: 300 }} />
                                </div>
                                : <>
                                    <div className="booking-header">
                                        <div className="booking-img-wrap">
                                            <div className="book-img">
                                                <ImageWithBasePath

                                                    src={bookingDetail && bookingDetail?.vehicle_image ? bookingDetail?.vehicle_image : "assets/img/cars/car-05.jpg"}

                                                    alt="img"
                                                />
                                            </div>
                                            <div className="book-info">
                                                <h6>{bookingDetail?.vehicle?.year_make_model}</h6>
                                                <p>
                                                    <i className="feather icon-map-pin" /> Location : {bookingDetail?.pickup_location}
                                                </p>
                                            </div>
                                        </div>
                                        <div className="book-amount">

                                            <span className="d-flex gap-1 align-items-center">
                                                <p>Payment Upfront:</p>
                                                <h6 className="text-danger fw-normal" >
                                                    ${bookingDetail?.cost_summary?.initialPayment}

                                                </h6>
                                            </span>
                                            <span className="d-flex gap-1 align-items-center">
                                                <p>  Upcoming Payment:

                                                    <span className="text-danger pe-1 fw-normal ">  ${bookingDetail?.cost_summary?.nextBillingCycle?.payment_amount}</span>

                                                    <span className="fw-normal ">on {bookingDetail?.cost_summary?.nextBillingCycle?.payment_date?.split(" ")[0]} </span>
                                                </p>

                                            </span>
                                        </div>
                                    </div>
                                    <div className="booking-group">
                                        <div className="booking-wrapper">
                                            <div className="booking-title">
                                                <h6>Booking Details</h6>
                                            </div>
                                            <div className="row">

                                                <div className="col-lg-4 col-md-6">
                                                    <div className="d-flex text-wrap align-items-center gap-1 booking-view">
                                                        <h6>Booking ID:    </h6>
                                                        <p>#{bookingDetail?.booking_id}</p>
                                                    </div>
                                                </div>

                                                {/* <div className="col-lg-4 col-md-6">
                                                    <div className="booking-view">
                                                        <h6>Pickup Location</h6>
                                                        <p>{bookingDetail?.pickup_location}</p>

                                                    </div>
                                                </div> */}


                                                <div className="col-lg-4 col-md-6">
                                                    <div className="d-flex text-wrap align-items-center gap-1 booking-view">
                                                        <h6>Payment:  </h6>
                                                        <p>{bookingDetail?.cost_summary?.paymentMethod?.name}</p>

                                                    </div>
                                                </div>



                                                <div className="col-lg-4 col-md-6">
                                                    <div className="d-flex text-wrap align-items-center gap-1 booking-view">
                                                        <h6>Booking Status:</h6>

                                                        <span className={` ${bookingDetail?.status?.name == "pending"
                                                            ? "badge badge-light-warning"
                                                            : bookingDetail?.status?.name == "confirmed"
                                                                ? "badge badge-light-primary"
                                                                : bookingDetail?.status?.name == "completed"
                                                                    ? "badge badge-light-success"
                                                                    : bookingDetail?.status?.name == "canceled"
                                                                        ? "badge badge-light-danger"
                                                                        : bookingDetail?.status?.name == "in_progress"
                                                                            ? "badge badge-light-secondary"
                                                                            : bookingDetail?.status?.name == "extended"
                                                                                ? "badge badge-light-warning"
                                                                                : "badge badge-light-info"
                                                            }`}
                                                        >

                                                            {bookingDetail?.status?.display_name}


                                                        </span>

                                                        {bookingDetail?.status?.name == "canceled" ? " (" + bookingDetail?.cancellation_reason + ")" : ""}


                                                    </div>
                                                </div>



                                                <div className="col-lg-4 col-md-6">
                                                    <div className="d-flex text-wrap align-items-center gap-1 booking-view">
                                                        <h6>License Status:</h6>

                                                        <span className={` ${bookingDetail?.license_status == "approved"
                                                            ? "badge badge-light-success"
                                                            : (bookingDetail?.license_status === "rejected" || bookingDetail?.license_status === "booking_canceled")
                                                                ? "badge badge-light-danger"
                                                                : bookingDetail?.license_status === "pending"
                                                                    ? "badge badge-light-warning"
                                                                    : bookingDetail?.license_status === "submitted"
                                                                        ? "badge badge-light-info"
                                                                        : bookingDetail?.license_status === "partially_approved"
                                                                            ? "badge badge-light-primary"
                                                                            : bookingDetail?.license_status === "partially_rejected"
                                                                                ? "badge badge-light-secondary"
                                                                                : "badge badge-light-light"
                                                            }`}
                                                        >

                                                            {bookingDetail?.license_status
                                                                ?.toLowerCase()
                                                                .replace(/_/g, " ") // Replace underscores with spaces
                                                                .replace(/^\w/, (c: string) => c.toUpperCase())}

                                                        </span>


                                                    </div>
                                                </div>


                                                <div className="col-lg-4 col-md-6">
                                                    <div className="d-flex text-wrap align-items-center gap-1 booking-view">
                                                        <h6>Agreement Status:  </h6>

                                                        <span className={` ${bookingDetail?.agreement_status === "approved"
                                                            ? "badge badge-light-success"
                                                            : (bookingDetail?.agreement_status === "rejected" || bookingDetail?.agreement_status === "booking_canceled")
                                                                ? "badge badge-light-danger"
                                                                : bookingDetail?.agreement_status === "pending_admin_action"
                                                                    ? "badge badge-info-subtle"
                                                                    : bookingDetail?.agreement_status === "pending"
                                                                        ? "badge badge-light-warning"
                                                                        : bookingDetail?.agreement_status === "submitted"
                                                                            ? "badge badge-light-info"
                                                                            : "badge badge-light-light"
                                                            }`}
                                                        >

                                                            {bookingDetail?.agreement_status
                                                                ?.toLowerCase()
                                                                .replace(/_/g, " ") // Replace underscores with spaces
                                                                .replace(/^\w/, (c: string) => c.toUpperCase())}

                                                        </span>


                                                    </div>
                                                </div>



                                                <div className="col-lg-4 col-md-6">
                                                    <div className="d-flex gap-1 align-items-center text-wrap booking-view">
                                                        <h6>Payment Status: </h6>


                                                        <span className={` ${bookingDetail?.payment_status == "approved"
                                                            ? "badge badge-light-success"
                                                            : (bookingDetail?.payment_status === "rejected" || bookingDetail?.payment_status === "booking_canceled")
                                                                ? "badge badge-light-danger"
                                                                : bookingDetail?.payment_status === "pending" || bookingDetail?.payment_status === "pending_request"
                                                                    ? "badge badge-light-warning"
                                                                    : bookingDetail?.payment_status === "submitted"
                                                                        ? "badge badge-light-info"
                                                                        : bookingDetail?.payment_status === "partially_approved"
                                                                            ? "badge badge-light-primary"
                                                                            : bookingDetail?.payment_status === "partially_rejected" || bookingDetail?.payment_status === "awaiting_payment"
                                                                                ? "badge badge-light-secondary"

                                                                                : "badge badge-light-light"
                                                            }`}
                                                        >

                                                            {bookingDetail?.payment_status
                                                                ?.toLowerCase()
                                                                .replace(/_/g, " ") // Replace underscores with spaces
                                                                .replace(/^\w/, (c: string) => c.toUpperCase())}

                                                        </span>



                                                    </div>
                                                </div>

                                                <div className="col-lg-4 col-md-6">
                                                    <div className="d-flex text-wrap gap-1 align-items-center booking-view">
                                                        <h6>Booked On:</h6>
                                                        <p>{BookedOn(bookingDetail)} </p>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-md-6">
                                                    <div className="d-flex text-wrap gap-1 align-items-center booking-view">
                                                        <h6>Start Date:</h6>

                                                        <p>     {SetDate(bookingDetail?.booking_start_date, bookingDetail?.booking_start_time)} </p>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-md-6">
                                                    <div className="d-flex text-wrap gap-1 align-items-center booking-view">
                                                        <h6  >End Date:</h6>
                                                        <p> {SetDate(bookingDetail?.booking_return_date, bookingDetail?.booking_return_time)}     </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                </>}

                        </div>
                    </div>
                </div>
            </div>}


        </>



    )
}

export default ViewBooking;

